import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";

import StorefrontIcon from "@mui/icons-material/Storefront";
import { makeStyles } from "@mui/styles";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import Logo from "./Logo";
import { useStateContext } from "../../context/StateContext_US";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LanguageIcon from "@mui/icons-material/Language";

import { useTranslation } from "react-i18next";

import Cleaner from "./Cleaner";
import Shoe from "./Shoe";
import Pet from "./Pet";
import { doc, setDoc, db } from "../../firebase";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Navigation from "./Navigation";

const settings = ["Dashboard", "Profile", "Order History", "Logout"];

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const useStyles = makeStyles({
  itemsOnHover: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "1.7em",
    alignItems: "center",
    textAlign: "center",
  },
  // link: { "&:hover": { backgroundColor: "white", color: "#36b4e6" } },
  top: {
    width: "100%",
    backgroundColor: "#78909c",
    paddingTop: "10px",
    paddingBottom: "10px",
    color: "white",
    fontSize: "11px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    letterSpacing: ".13rem",
  },
  popular: {
    paddingTop: "3px",
    fontSize: "12px",
    backgroundColor: "#f3756d",
    marginTop: "10px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "none",
    width: "100px",
    borderRadius: "20px",
  },
});

const Navbar = (props) => {
  const { t, i18n } = useTranslation();
  const { currentUser } = useAuth();
  let navigate = useNavigate();
  const classes = useStyles();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const { basket, getBasketQuantity } = useStateContext();

  const changeLanguage = () => {
    if (i18n.language === "en") {
      i18n.changeLanguage("ko");
      localStorage.setItem("language", "ko");
      if (currentUser) {
        const cityRef = doc(db, "users", currentUser.uid);
        setDoc(cityRef, { language: "ko" }, { merge: true });
      }
    } else {
      i18n.changeLanguage("en");
      localStorage.setItem("language", "en");
      if (currentUser) {
        const cityRef = doc(db, "users", currentUser.uid);
        setDoc(cityRef, { language: "en" }, { merge: true });
      }
    }
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (page) => {
    // setAnchorElNav(null);
    // navigate("/" + page);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // user menu

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    console.log(event);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (page) => {
    setAnchorEl(null);

    if (page?.type) {
      handleCloseNavMenu();
    } else {
      navigate("/" + page);
      handleCloseNavMenu();
    }
  };

  return (
    <>
      {/* <Fade delay={50}> */}
      <Box className={classes.top}>{t("USFreeShip")}</Box>

      <Grid
        container
        sx={{
          width: 1,
          display: "flex",
          // justifyContent: "space-between",
          pt: 2,
          pb: 1,
          px: 10,
          borderBottom: "1px solid lightgray",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
          position: "relative",
          zIndex: 100,
        }}
      >
        <Grid
          item
          md={1}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <HashLink to="/" smooth>
            <img
              src="/img/heslet_logo.png"
              width="20"
              alt="logo"
              style={{
                position: "relative",
                top: "-2px",
                paddingRight: "5px",
              }}
            />
          </HashLink>
          <Box sx={{ fontSize: "15px", position: "relative", top: "-1px" }}>
            <HashLink to="/" smooth>
              Heslet
            </HashLink>
          </Box>
        </Grid>
        <Grid
          item
          md={4}
          sx={{
            display: { md: "flex", sm: "none", sx: "none" },
            alignItems: "center",
            pl: 2,
          }}
        >
          <Cleaner />
          <Shoe />
          <Pet />
          <Box sx={{ pl: "19px" }}>
            <HashLink to="/technology">{t("Technology upper")}</HashLink>
          </Box>
          <Box sx={{ pl: "19px" }}>
            <HashLink to="/contact#top">{t("Contact Us nav")}</HashLink>
          </Box>
        </Grid>
        <Grid
          item
          md={7}
          sx={{
            width: 1,
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box>
            <LanguageIcon
              onClick={changeLanguage}
              sx={{
                fontSize: "20px",
                zIndex: 100,
                cursor: "pointer",
                color: "gray",
                mt: "3px",
                mr: "5px",
              }}
            />
          </Box>
          <Box sx={{}}>
            {(currentUser &&
              window.sessionStorage.getItem("position") === "admin") ||
            (currentUser &&
              window.sessionStorage.getItem("position") === "manager") ? (
              <IconButton
                component={Link}
                to="/admin/dashboard"
                aria-label="cart"
              >
                <StorefrontIcon sx={{ fontSize: "18x" }} />
              </IconButton>
            ) : null}
          </Box>
          <Box
            sx={{
              width: "fit-content",
            }}
          >
            <IconButton component={Link} to="/cart" aria-label="cart">
              <StyledBadge
                badgeContent={getBasketQuantity()}
                color="secondary"
                sx={{ fontSize: "7px" }}
              >
                <ShoppingCartIcon sx={{ fontSize: "20px" }} />
              </StyledBadge>
            </IconButton>
          </Box>
          {currentUser ? (
            <>
              <Navigation />
            </>
          ) : (
            ""
          )}
          {!currentUser ? (
            <Box
              sx={{
                width: "fit-content",
                border: "1px solid lightgray",
                p: 1,
                borderRadius: "20%",
                ml: 2,
                fontSize: "11px",
                // color: "#571c6d",
                fontWeight: 800,
                py: 1,
                marginBottom: "11px",
                marginTop: "6px",
              }}
            >
              <HashLink to="/login" smooth>
                {t("Log in")}
              </HashLink>
            </Box>
          ) : null}
        </Grid>
      </Grid>
      {/* <Box
        sx={{
          width: 1,
          display: "flex",
          justifyContent: "space-between",
          pt: 3,
          pb: 2,
          px: 12,
          borderBottom: "1px solid lightgray",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
          position: "relative",
          zIndex: 100,
        }}
      >
        <Box
          sx={{
            display: "flex",
            // border: "1px solid black",
            alignItems: "center",
            alignItems: "center",
          }}
        >
          <HashLink to="/" smooth>
            <img
              src="/img/heslet_logo.png"
              width="20"
              alt="logo"
              style={{
                position: "relative",
                top: "-2px",
                paddingRight: "5px",
              }}
            />
          </HashLink>
          <Box sx={{ fontSize: "17px", position: "relative", top: "-1px" }}>
            <HashLink to="/" smooth>
              Heslet
            </HashLink>
          </Box>
        </Box>
        <Box>abcs</Box>
      </Box> */}
      {/* <HashLink smooth to={"#top"}>
        <Box
          sx={{
            position: "fixed",
            zIndex: 100,
            right: 0,
            bottom: 60,
            width: "40px",
            height: "40px",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "gray",
            backgroundColor: "#f4eddd",
          }}
        >
          <ArrowUpwardIcon sx={{ color: "gray", fontSize: "14px" }} />
        </Box>
      </HashLink> */}
      {/* </Fade> */}
    </>
  );
};
export default Navbar;
